import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import { connect, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";

import { NavigationRoutes } from "../../constant/Routes";
import {
    articleListingRequest,
    deleteArticle,
} from "./redux/articleDispatcher";

function ArticleListingTable({ articleListing }) {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    /**
     * COLUMNS
     */
    const columns = [
        {
            field: "id",
            headerName: "NO",
            width: 50,
            renderCell: (params) =>
                params.api.getRowIndexRelativeToVisibleRows(params.id) +
                1 +
                page * pageSize,
        },

        {
            field: "category_name",
            headerName: "Category",
            width: 100,
        },

        {
            field: "title",
            headerName: "Title",
            width: 200,
        },

        {
            field: "label",
            headerName: "Label",
            width: 150,
        },

        {
            field: "helpfulCount",
            headerName: "Helpful",
            width: 60,
        },

        {
            field: "notHelpfulCount",
            headerName: "Not Helpful",
            width: 60,
        },

        {
            field: "created_at",
            headerName: "Created At",
            width: 200,
            renderCell: (params) => {
                const date = new Date(params.row.created_at);
                return <div>{date.toLocaleString()}</div>;
            },
        },

        {
            field: "action",
            headerName: "Action",
            width: 250,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div
                        style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        {/* VIEW / EDIT */}
                        <button
                            onClick={() => {
                                navigate(
                                    NavigationRoutes.ADMIN_DASHBOARD +
                                    NavigationRoutes.EDIT_ARTICLE.replace(
                                        ":id",
                                        `${params.row.id}`
                                    )
                                );
                            }}
                            style={btnStyle("#000")}
                        >
                            View
                        </button>

                        {/* DELETE */}
                        <button
                            onClick={() => handleDelete(params.row)}
                            style={btnStyle("#F44336")}
                        >
                            Delete
                        </button>
                    </div>
                );
            },
        },
    ];

    /**
     * DELETE HANDLER
     */
    const handleDelete = (row) => {
        Swal.fire({
            html:
                "Are you sure?<br>" +
                `You want to delete article "<b>${row.title}</b>"`,
            showCancelButton: true,
            confirmButtonText: "Yes, Delete",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#4f83df",
            cancelButtonColor: "gray",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteArticle(row.id));
            }
        });
    };

    /**
     * FETCH LIST
     */
    React.useEffect(() => {
        dispatch(articleListingRequest(page + 1, pageSize));
    }, [dispatch, page, pageSize, location.pathname]);

    return (
        <Paper sx={{ height: "95%", width: "100%" }}>
            {/* ADD BUTTON */}
            <div style={{ padding: "10px", display: "flex", justifyContent: "end" }}>
                <button
                    onClick={() =>
                        navigate(
                            NavigationRoutes.ADMIN_DASHBOARD +
                            NavigationRoutes.ADD_ARTICLE
                        )
                    }
                    style={btnStyle("#000")}
                >
                    Add Article
                </button>
            </div>

            {/* TABLE */}
            <DataGrid
                rows={articleListing.articleListing || []}
                columns={columns}
                rowCount={articleListing.totalArticle || 0}
                paginationMode="server"
                page={page}
                pageSize={pageSize}
                pageSizeOptions={[10, 25, 50]}
                loading={articleListing.loading}
                paginationModel={{ page, pageSize }}
                onPaginationModelChange={(model) => {
                    setPage(model.page);
                    setPageSize(model.pageSize);
                }}
                rowHeight={70}
                sx={{ border: 0 }}
            />
        </Paper>
    );
}

/**
 * BUTTON STYLE
 */
const btnStyle = (bg) => ({
    backgroundColor: bg,
    color: "white",
    border: "none",
    cursor: "pointer",
    borderRadius: "4px",
    fontSize: "11px",
    width: "90px",
    height: "26px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});

/**
 * REDUX
 */
const mapStateToProps = (state) => ({
    articleListing: state.articleReducer,
});

export default connect(mapStateToProps)(ArticleListingTable);